// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"U3-z","displaySixCardTiles":"V3-z"};